import React, { useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { postInterest } from './interestApi';
import PreviewDialog from './PreviewDialog';

const lastQuarterEnd = () => {
  const d = new Date();
  const q = Math.floor(d.getMonth() / 3);
  return new Date(d.getFullYear(), q * 3 + 3, 0); // last day of previous quarter
};

export default function InterestPosting({ onPosted }) {
  const toast = useRef(null);
  const [date, setDate] = useState(lastQuarterEnd());
  const [busy, setBusy] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const iso = (d) => d && d.toISOString().slice(0, 10);

  const doPost = async () => {
    setBusy(true);
    try {
      const res = await postInterest(iso(date));
      toast.current.show({
        severity: 'success',
        summary: 'Posted',
        detail: `${res.message} Accounts: ${res.accountsAffected}, Total: ₹${res.totalInterest}`,
        life: 5000,
      });
      onPosted?.();
    } catch (e) {
      const msg = e?.response?.data?.message || e.message;
      const sev = e?.response?.status === 409 ? 'warn' : 'error';
      toast.current.show({ severity: sev, summary: 'Posting', detail: msg, life: 5000 });
    } finally {
      setBusy(false);
    }
  };

  const confirmPost = () => {
    confirmDialog({
      message: `Post quarterly interest for quarter ending ${iso(date)}? This cannot be undone automatically.`,
      header: 'Confirm Interest Posting',
      icon: 'pi pi-exclamation-triangle',
      acceptClassName: 'p-button-danger',
      accept: doPost,
    });
  };

  return (
    <Card title="Quarterly Savings Interest Posting" className="mb-3">
      <Toast ref={toast} />
      <ConfirmDialog />

      <div className="flex flex-wrap gap-3 align-items-end">
        <div className="flex flex-column gap-2">
          <label htmlFor="qend">Quarter End Date</label>
          <Calendar id="qend" value={date} onChange={e => setDate(e.value)}
                    dateFormat="yy-mm-dd" showIcon readOnlyInput />
        </div>

        <Button label="Preview" icon="pi pi-search" severity="secondary" outlined
                onClick={() => setPreviewOpen(true)} disabled={!date} />

        <Button label="Post Interest" icon="pi pi-check" loading={busy}
                onClick={confirmPost} disabled={!date} />
      </div>

      <small className="block mt-3 text-color-secondary">
        Interest is posted to <code>savingstransaction</code> with narration{' '}
        <em>Quarterly Interest Paid</em>. Re-posting the same quarter is rejected.
      </small>

      <PreviewDialog visible={previewOpen}
                     onHide={() => setPreviewOpen(false)}
                     quarterEndDate={iso(date)} />
    </Card>
  );
}